// import React, { useState, useEffect, useCallback } from 'react';
// import { Card, CardTitle, CardBody, Button, Input, Table } from 'reactstrap';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import { useSelector } from 'react-redux';
// import VendorBranchSelector from '../../components/VendorBranchSelector';

// const formatTime = (value) => {
//   if (!value) return '';
//   return String(value).substring(0, 5);
// };

// const TimeTableList = () => {
//   const { user } = useSelector((state) => state.authState || {});
//   const navigate = useNavigate();

//   const [list, setList] = useState([]);
//   const [search, setSearch] = useState('');
//   const [selectionData, setSelectionData] = useState({
//     vendor_id: '',
//     branch_id: '',
//   });

//   const safeSelectionData = selectionData || {
//     vendor_id: '',
//     branch_id: '',
//   };

//   const GetList = useCallback(
//     async (searchText = '') => {
//       try {
//         const vendorId = safeSelectionData?.vendor_id || '';
//         const branchId = safeSelectionData?.branch_id || '';

//         const response = await apiService.get(
//           `api/TimeTableMaster/GetAllTimeTable?vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(searchText || '')}`,
//         );

//         if (response.status === true) {
//           setList(response.data || []);
//         } else {
//           alert(response.message || 'Failed');
//           setList([]);
//         }
//       } catch (err) {
//         console.error(err);
//         alert('Something went wrong');
//         setList([]);
//       }
//     },
//     [safeSelectionData?.vendor_id, safeSelectionData?.branch_id],
//   );

//   useEffect(() => {
//     if (safeSelectionData?.vendor_id && safeSelectionData?.branch_id) {
//       GetList(search);
//     } else {
//       setList([]);
//     }
//   }, [
//     safeSelectionData?.vendor_id,
//     safeSelectionData?.branch_id,
//     GetList,
//     search,
//   ]);

//   const onEdit = (row) => {
//     navigate('/save-class-routine', { state: row });
//   };

//   return (
//     <>
//       <div className='text-right mb-2'>
//         <Button color='primary' onClick={() => navigate('/save-class-routine')}>
//           Add Time Table
//         </Button>
//       </div>

//       <Card className='card-box pd-20 mb-20'>
//         <CardTitle className='border-bottom p-3 mb-0'>Filter</CardTitle>
//         <CardBody>
//           <VendorBranchSelector
//             user={user || {}}
//             selectionData={safeSelectionData}
//             setSelectionData={setSelectionData}
//             errorMessage={{}}
//             accessButton={true}
//           />
//         </CardBody>
//       </Card>

//       <Card className='card-box pd-20 mb-20'>
//         <CardTitle className='p-3 mb-0'>Time Table List</CardTitle>

//         <div className='p-2'>
//           <Input
//             placeholder='Search by class / batch / subject / faculty / day'
//             value={search}
//             onChange={(e) => {
//               const value = e.target.value;
//               setSearch(value);

//               if (
//                 safeSelectionData?.vendor_id &&
//                 safeSelectionData?.branch_id
//               ) {
//                 GetList(value);
//               }
//             }}
//           />
//         </div>

//         <CardBody>
//           <Table striped hover responsive>
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Edit</th>
//                 <th>Class</th>
//                 <th>Batch</th>
//                 <th>Day</th>
//                 <th>Start</th>
//                 <th>End</th>
//                 <th>Subject</th>
//                 <th>Faculty</th>
//               </tr>
//             </thead>
//             <tbody>
//               {list.length > 0 ? (
//                 list.map((x, i) => (
//                   <tr key={x.id}>
//                     <td>{i + 1}</td>
//                     <td>
//                       <i
//                         className='bi bi-pencil text-primary'
//                         style={{ cursor: 'pointer' }}
//                         onClick={() => onEdit(x)}
//                       />
//                     </td>
//                     <td>{x.class_name || x.class_id}</td>
//                     <td>{x.batch_name || x.batch_id}</td>
//                     <td>{x.day_name || x.day_id}</td>
//                     <td>{formatTime(x.start_time)}</td>
//                     <td>{formatTime(x.end_time)}</td>
//                     <td>{x.subject_name || x.subject_id}</td>
//                     <td>{x.faculty_name || x.faculty_id}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan='9' className='text-center'>
//                     No data found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default TimeTableList;
//heena new
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Card, CardTitle, CardBody, Button, Input, Table } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import { useSelector } from 'react-redux';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import useVendorBranch from '../../utils/useVendorBranch';
import {
  createAppConnection,
  joinModuleGroup,
  leaveModuleGroup,
  subscribeRealtimeUpdate,
  unsubscribeRealtimeUpdate,
} from '../../utils/signalRService';

const MODULE_NAME = 'TimeTable';

const formatTime = (value) => {
  if (!value) return '';
  return String(value).substring(0, 5);
};

const TimeTableList = () => {
  const { user } = useSelector((state) => state.authState || {});
  const navigate = useNavigate();

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});
  const [list, setList] = useState([]);
  const [search, setSearch] = useState('');
  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const currentGroupRef = useRef({
    module: null,
    vendorId: null,
    branchId: null,
  });

  const onHandleAdd = () => {
    navigate('/save-class-routine');
  };

  const onEdit = (row) => {
    navigate('/save-class-routine', { state: row });
  };

  const GetList = useCallback(async (searchText = '') => {
    try {
      const vendorId = selectionData?.vendor_id || '';
      const branchId = selectionData?.branch_id || '';

      const response = await apiService.get(
        `api/TimeTableMaster/GetAllTimeTable?vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(searchText || '')}`,
      );

      if (response?.status === true) {
        setList(response?.data || []);
      } else {
        alert(response?.message || 'Failed');
        setList([]);
      }
    } catch (err) {
      console.error(err);
      alert('Something went wrong');
      setList([]);
    }
  }, [selectionData?.vendor_id, selectionData?.branch_id]);

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData?.vendor_id,
      branchId: selectionData?.branch_id,
    });

    if (canLoad) {
      GetList(search);
    } else {
      setList([]);
    }
  }, [
    selectionData?.vendor_id,
    selectionData?.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
    GetList,
    search,
  ]);

  useEffect(() => {
    let mounted = true;

    const setupSignalR = async () => {
      try {
        await createAppConnection();

        const vendorId = selectionData?.vendor_id || 0;
        const branchId = selectionData?.branch_id || 0;

        const prev = currentGroupRef.current;

        if (
          prev.vendorId &&
          prev.branchId &&
          (String(prev.vendorId) !== String(vendorId) ||
            String(prev.branchId) !== String(branchId))
        ) {
          await leaveModuleGroup(prev.module, prev.vendorId, prev.branchId);
        }

        if (vendorId && branchId) {
          await joinModuleGroup(MODULE_NAME, vendorId, branchId);

          currentGroupRef.current = {
            module: MODULE_NAME,
            vendorId,
            branchId,
          };
        }

        unsubscribeRealtimeUpdate();

        await subscribeRealtimeUpdate((payload) => {
          if (!mounted) return;
          if (!payload) return;

          const isSameModule = String(payload.module || '') === MODULE_NAME;
          const isSameVendor =
            String(payload.vendorId || '') === String(vendorId || '');
          const isSameBranch =
            String(payload.branchId || '') === String(branchId || '');

          if (isSameModule && isSameVendor && isSameBranch) {
            console.log('TimeTable realtime update received:', payload);
            GetList(search);
          }
        });
      } catch (err) {
        console.error('SignalR error:', err);
      }
    };

    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData?.vendor_id,
      branchId: selectionData?.branch_id,
    });

    if (canLoad) {
      setupSignalR();
    }

    return () => {
      mounted = false;
    };
  }, [
    selectionData?.vendor_id,
    selectionData?.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
    GetList,
    search,
  ]);

  useEffect(() => {
    return () => {
      unsubscribeRealtimeUpdate();

      const prev = currentGroupRef.current;
      if (prev?.vendorId && prev?.branchId) {
        leaveModuleGroup(prev.module, prev.vendorId, prev.branchId).catch(
          console.error,
        );
      }
    };
  }, []);

  return (
    <>
      <div className='text-right mb-2'>
        <Button color='primary' onClick={onHandleAdd}>
          Add Time Table
        </Button>
      </div>

      <VendorBranchSelector
        user={user || {}}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='p-3 mb-0'>Time Table List</CardTitle>

        <div className='p-2'>
          <Input
            placeholder='Search by class / batch / subject / faculty / day'
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>

        <CardBody>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Edit</th>
                <th>Class</th>
                <th>Batch</th>
                <th>Day</th>
                <th>Start</th>
                <th>End</th>
                <th>Subject</th>
                <th>Faculty</th>
              </tr>
            </thead>
            <tbody>
              {list.length > 0 ? (
                list.map((x, i) => (
                  <tr key={x.id}>
                    <td>{i + 1}</td>
                    <td>
                      <i
                        className='bi bi-pencil text-primary'
                        style={{ cursor: 'pointer' }}
                        onClick={() => onEdit(x)}
                      />
                    </td>
                    <td>{x.class_name || x.class_id}</td>
                    <td>{x.batch_name || x.batch_id}</td>
                    <td>{x.day_name || x.day_id}</td>
                    <td>{formatTime(x.start_time)}</td>
                    <td>{formatTime(x.end_time)}</td>
                    <td>{x.subject_name || x.subject_id}</td>
                    <td>{x.faculty_name || x.faculty_id}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan='9' className='text-center'>
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default TimeTableList;